import { Element } from '../../../../../common/html/element'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatVal, valToPercent } from '../../../../../helpers/value'
import { SCHEMA } from '../constants'

export const FormatVal = ({ val, locale, year, rowId }) => {
  const { formatCurrency } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  const { value, growth } = val

  return (
    <>
      <div style={{ textAlign: 'right' }}>
        {rowId === SCHEMA.industryNetRevenue.key
          ? formatCurrency({
              value,
              year,
              isFinancialStatement: true,
              exchangeRateType: 'lastDayRate',
            })
          : rowId === SCHEMA.industryTotalAssets.key
          ? formatCurrency({
              value,
              year,
              isFinancialStatement: true,
              exchangeRateType: 'lastDayRate',
            })
          : formatVal(value, locale, false, 0)}
      </div>

      <Element
        style={{
          fontSize: 10,
          textAlign: 'right',
          color: growth > 0 ? '#3DA967' : growth < 0 ? '#E0505B' : '#FFCD60',
        }}
      >
        {growth > 0 && '+'}
        {valToPercent(growth, locale)}
      </Element>
    </>
  )
}
